<template>
    <Bank :id="Number(id)"/>
</template>
<script>
import Bank from '@/components/Bank.vue';

export default {
    components: {
        Bank
    },
    name: 'BankProfileView',
    data() {
        return {
            // Инициализация компонента Bank с id 0 для добавления нового банка
            id: this.$route.params.id || '0'
        }
    }
}
</script>